import React from 'react';

import { MarketplaceSaleChannelType } from '@anyx/common-graphql';

const TikTokAddPage = React.lazy(() =>
  import('./pages/add').then((module) => ({ default: module.TikTokAddPage }))
);

const TikTokEditPage = React.lazy(() =>
  import('./pages/edit').then((module) => ({ default: module.TikTokEditPage }))
);

const TikTokTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.TikTokTemplate }))
);

export const tikTokRouting = [
  {
    path: MarketplaceSaleChannelType.TikTok,
    element: <TikTokTemplate />,
    children: [
      {
        index: true,
        element: <TikTokAddPage />,
      },
      {
        path: ':channelId',
        children: [
          {
            index: true,
            element: <TikTokEditPage />,
          },
        ],
      },
    ],
  },
];
